import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getBuildType} from '../../../../selectors'
import {getPolicyHolderIds} from '../CleanupProjectPage.utils'

import HolderItem from './HolderItem'
import type {OwnProps, StateProps} from './HolderItem.types'

const mapStateToProps = (state: State, {type, externalId}: OwnProps): StateProps => {
  const {buildTypeId} = getPolicyHolderIds(
    {
      externalId,
    },
    type,
  )

  return {
    isComposite: getBuildType(state, buildTypeId)?.type === 'composite',
  }
}

export default connect(mapStateToProps, {})(HolderItem)
